/* eslint-disable jsx-a11y/media-has-caption */
import { Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useState } from 'react';
import ChatMessageCaption from '../ChatMessage/ChatMessageCaption';

type ChatMessageVideoProps = {
  mediaUrl: string;
  mediaSize?: string;
  caption?: string;
};

const ChatMessageVideo: React.FC<ChatMessageVideoProps> = ({
  mediaUrl,
  caption,
}) => {
  const [isLoadedVideo, setIsLoadedVideo] = useState(false);

  return (
    <ChatMessageCaption caption={caption}>
      <Paper style={{ overflow: 'hidden', lineHeight: 0 }} elevation={0}>
        {!isLoadedVideo && (
          <Skeleton
            variant="rect"
            width={330}
            height={280}
            style={{ borderRadius: 5, backgroundColor: '#d7d7da' }}
          />
        )}
        <video
          controls
          onLoadedData={() => {
            setIsLoadedVideo(true);
          }}
          src={mediaUrl}
          style={{
            maxHeight: 330,
            maxWidth: '100%',
            width: 'auto',
            display: isLoadedVideo ? 'block' : 'none',
          }}
        />
      </Paper>
    </ChatMessageCaption>
  );
};

export default ChatMessageVideo;
